import { Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { GenericService } from '../../services';
import { CodiceFiscale, ResponseStatusCodes } from '../../models';

@Component({
    moduleId: module.id,
    selector: 'codice-fiscale',
    templateUrl: 'codice-fiscale.html'
})
export class CodiceFiscaleComponent {


    constructor(private genericService: GenericService) { }

    _value: string;
    @ViewChild('inputRef') inputRef: HTMLInputElement;
    @Output() valueChange = new EventEmitter();
    @Output() onCodiceFiscaleEmitter = new EventEmitter();
    @Input() parentId: string;
    @Input() disabled: boolean = false;
    @Input() readOnly: boolean = false;
    
    @Input()
    get value() {
        return this._value;
    }
    set value(val) {
        this._value = val;
        this.valueChange.emit(this._value);
    }

    onCodiciFiscaleClick() {
        let param = {
            control: this,
            parentId: this.parentId
        };
        this.onCodiceFiscaleEmitter.emit(param);
    }

    calcolaCFbyRiga(indiceRiga: number) {
        let cognome: string = (document.getElementsByName("COGNOME_" + indiceRiga)[0] as HTMLInputElement).value;
        let nome: string = (document.getElementsByName("NOME_" + indiceRiga)[0] as HTMLInputElement).value;
        let comunenascita: string = (document.getElementsByName("COMUNE_" + indiceRiga)[0] as HTMLInputElement).value;
        let datanascita = (document.getElementsByName("DATA_NASCITA_" + indiceRiga)[0].getElementsByTagName("input")[0] as HTMLInputElement).value;
        let sesso: string = (document.getElementsByName("SESSO_" + indiceRiga)[0] as HTMLSelectElement).value;
        this.calcolaCF(nome, cognome, datanascita, comunenascita, sesso);
    }

    calcolaCF(nome: string, cognome: string, dataDiNascita: string, comunediNascita: string, sesso: string) {
        let codiceFiscale: CodiceFiscale = new CodiceFiscale();
        codiceFiscale.cognome = cognome;
        codiceFiscale.nome = nome;
        codiceFiscale.dataDiNascita = dataDiNascita;
        codiceFiscale.sesso = sesso;
        codiceFiscale.comuneNascita = comunediNascita;
        this.genericService
            .calcolaCodiceFiscale(codiceFiscale)
            .then(datiResponse => {
                if (datiResponse.status == ResponseStatusCodes.OK) {
                    this.value = datiResponse.payload;
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/components/codice-fiscale/codice-fiscale.component.ts